// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__dF1f6","titleBlock":"PageHeader_titleBlock__UMxge","title":"PageHeader_title__zMEPz","subtitle":"PageHeader_subtitle__XORAd"};